const CheckAllIcon = ({ size = 15 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 18 12"
    >
      <path
        d="M1 6.5l3 3 6.5-7M8 9.5l.6.6L16 3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckAllIcon;
